import { HttpErrorResponse } from '@angular/common/http';

export function getErrorMessage(error: unknown): string | undefined {
  if (error instanceof Error || error instanceof HttpErrorResponse) {
    return error.message;
  }
  return typeof error === 'string' ? error : undefined;
}
